import React, { useEffect, useState } from "react"
import { Button, Confirm, Image } from "semantic-ui-react"
import { connect } from "react-redux"
import { useTranslation, withTranslation } from "react-i18next"
import {
  getFilteredListOfTires,
  getRimSize,
  resetTireData,
  saveSelectedTire,
  saveTireDetails,
  saveTireSizeDetails
} from "../../actions/tire_action/tiresActions"
import TopTireShimmer from "./TopTireShimmer"
import {
  TIRE_FILTER_CHECKBOX,
  TIRE_FILTER_PRICE,
  TIRE_FILTER_RANGE,
  TIRE_FILTER_SORTING,
  TIRE_SORTING_FILTER_OPTIONS
} from "../../constants/tires"
import TierTopIcon from "../../assets/images/tier-top-Icon.svg"
import CarIconForUpdate from "../../assets/images/car_icon_for_update.svg"
import { formatParagraph } from "../../helpers/stringHelpers"
import { get, isEmpty, set, unset } from "lodash"
import TireDetailsSize from "./TireSizeDetails"
import CartWarningDialog from "./CartWarningDialog"
import TireFilterAndSearch360 from "./TireFilterAndSearch360"
import FilterLogo from "../../assets/images/tire-filter.svg"
import ReactSVG from "react-svg"
import FilterDrawer from "./FilterDrawer"
import TireAppliedFilters from "./TireAppliedFilters"
import { isMobile, isTablet } from "react-device-detect"
import {
  areTireFiltersEmpty,
  manageTireFilters,
  prepareFilterAPIParams,
  shouldApplyFilterRendered,
  transformString
} from "../../utilities/TireFilterHelpers"
import { TiresBottomNav } from "../../layouts/TiresLayout"
import { navigationPaths } from "../../constants/paths"
import { gaJSON, trackFirebaseAnalytics } from "../../helpers/googleAnalyticsHelpers"

function SelectTire({
  activeVehicle,
  saveTireDetails,
  savedTires,
  getFilteredListOfTires,
  selectedTireSizeData,
  saveSelectedTire,
  history,
  preSelectedFilters,
  dispatch,
  cartTiersQuantity,
  user
}) {
  const [isLoading, setIsLoading] = useState(true)
  const [tires, setTires] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [openCarWarningDialog, setOpenCarWarningDialog] = useState(false)
  const [tireQty, setTireQty] = useState(
    savedTires && savedTires.length > 0
      ? [{ tireId: savedTires[0].id, quantity: cartTiersQuantity, price: savedTires[0].price }]
      : []
  )
  const objectCollection = [
    { id: 1, label: "1" },
    { id: 2, label: "2" },
    { id: 3, label: "3" },
    { id: 4, label: "4" }
  ]
  const [selectedTire, setSelectedTire] = useState(
    savedTires && savedTires.length > 0
      ? {
          id: savedTires[0].id
        }
      : {}
  )

  const [openFilterDrawer, setOpenFilterDrawer] = useState(false)
  const [tireSelectedFilters, setTireSelectedFilters] = useState(preSelectedFilters)
  const [isFilterApiCalling, setFilterApiCalling] = useState(false)
  const [isFilterAppliedOnMobile, setIsFilterAppliedOnMobile] = useState(false)
  const [filters, setFilters] = useState([])

  const { t } = useTranslation("topTiers")
  const handleFilterApiLoader = () => {
    setFilterApiCalling((prev) => !prev)
  }

  const handleSelectedFilter = (selectedFilter, filterType, filterCategory) => {
    const localFilterCategory =
      filterCategory === TIRE_FILTER_SORTING || filterCategory === TIRE_FILTER_RANGE

    manageTireFilters({
      selectedFilter,
      filterType,
      filterCategory,
      setTireSelectedFilters,
      fetchTireData
    })
  }

  const handleClearFilter = (filterType, filterLabel, filterCategory) => {
    setTireSelectedFilters((prevFilters) => {
      const currentFilters = get(prevFilters, filterType, {})
      if (filterCategory === TIRE_FILTER_CHECKBOX) {
        const checkboxFilters = get(currentFilters, TIRE_FILTER_CHECKBOX, [])
        set(
          prevFilters,
          `${filterType}.${TIRE_FILTER_CHECKBOX}`,
          checkboxFilters.filter((label) => label !== filterLabel)
        )
      } else if (filterCategory === TIRE_FILTER_RANGE) {
        unset(prevFilters, `${filterType}.${TIRE_FILTER_RANGE}`)
      } else if (filterCategory === TIRE_FILTER_SORTING) {
        unset(prevFilters, `${filterType}.${TIRE_FILTER_SORTING}`)
      }

      if (isMobile || isTablet) {
        setIsFilterAppliedOnMobile(areTireFiltersEmpty(prevFilters))
      }

      isMobile || isTablet ? fetchTireDataOnMobile(prevFilters) : fetchTireData(prevFilters)

      return { ...prevFilters }
    })
  }

  const handleClearAllFilters = (wantToTriggerAPI = false) => {
    setTireSelectedFilters({})
    setIsFilterAppliedOnMobile(false)

    if (wantToTriggerAPI) {
      getFilteredListOfTires({
        payload: {
          cartireids: selectedTireSizeData.value,
          ...prepareFilterAPIParams({})
        },
        callback: (status, data) => {
          setIsLoading(false)
          if (status === "success") {
            setTires(data.tires || [])
          }
        }
      })
    }
  }

  const fetchTireData = async (filters = {}) => {
    if (!isMobile && !isTablet) {
      try {
        setIsLoading(true)
        handleFilterApiLoader()
        let updatedFilters = {}
        if (filters?.sorting) {
          updatedFilters = {
            ...tireSelectedFilters,
            ...filters
          }
        } else {
          updatedFilters = {
            ...tireSelectedFilters,
            ...filters,
            [TIRE_FILTER_SORTING]: {
              ...tireSelectedFilters[TIRE_FILTER_PRICE],
              [TIRE_FILTER_SORTING]: filters?.price?.sorting ?? "name"
            }
          }
        }
        getFilteredListOfTires({
          payload: {
            cartireids: selectedTireSizeData.value,
            ...prepareFilterAPIParams(updatedFilters)
          },
          callback: (status, data) => {
            setIsLoading(false)
            if (status === "success") {
              setTires(data.tires || [])
            }
          }
        })
      } catch (error) {
      } finally {
        handleFilterApiLoader()
      }
    }
  }

  const fetchTireDataOnMobile = async (filters = {}) => {
    try {
      setIsLoading(true)
      handleFilterApiLoader()
      setIsFilterAppliedOnMobile(true)
      let updatedFilters = {}
      if (filters?.sorting) {
        updatedFilters = {
          ...tireSelectedFilters,
          ...filters
        }
      } else {
        updatedFilters = {
          ...tireSelectedFilters,
          ...filters,
          [TIRE_FILTER_SORTING]: {
            ...tireSelectedFilters[TIRE_FILTER_PRICE],
            [TIRE_FILTER_SORTING]: filters?.price?.sorting
          }
        }
      }
      getFilteredListOfTires({
        payload: {
          cartireids: selectedTireSizeData.value,
          ...prepareFilterAPIParams(updatedFilters)
        },
        callback: (status, data) => {
          setIsLoading(false)
          if (status === "success") {
            setTires(data.tires || [])
          }
        }
      })
    } catch (error) {
    } finally {
      handleFilterApiLoader()
    }
  }

  const shoppingItems = savedTires.reduce((prev, next) => prev + next.quantity, 0)

  const handleFilterDrawer = () => {
    setOpenFilterDrawer((prev) => !prev)
  }

  const openDeleteModal = (tire) => {
    setSelectedTire(tire)
    setOpenModal(true)
  }

  const closeModal = () => {
    setOpenModal(false)
  }

  const handleDeleteTire = () => {
    setSelectedTire({})
    setTireQty([])
    const finalArr = savedTires.filter((item) => item.tireId !== selectedTire.id)
    saveTireDetails(finalArr)
    dispatch({
      type: "TIRE_CART_ITEM",
      payload: {
        cartTireObject: null,
        tireQuantity: 0
      }
    })
    closeModal()
  }

  useEffect(() => {
    getFilteredTopTires()
  }, [])

  const getFilteredTopTires = async () => {
    if (!isEmpty(selectedTireSizeData)) {
      setIsLoading(true)
      const updatedFilters = {
        ...tireSelectedFilters,
        [TIRE_FILTER_SORTING]: {
          ...tireSelectedFilters[TIRE_FILTER_PRICE],
          [TIRE_FILTER_SORTING]: filters?.price?.sorting ?? "name"
        }
      }
      getFilteredListOfTires({
        payload: {
          cartireids: selectedTireSizeData.value,
          ...prepareFilterAPIParams(updatedFilters)
        },
        callback: (status, data) => {
          setIsLoading(false)
          if (status === "success") {
            setTires(data.tires || [])
            setFilters(data.filters || [])
          }
        }
      })
    }
  }
  const changeHandler = (event, data, tire) => {
    const tempArr = tireQty ? tireQty.filter((item) => item.tireId !== tire.id) : []
    const finalArr = [...tempArr, { tireId: tire.id, quantity: data.value.id, price: tire.price }]
    setTireQty(finalArr)
    const isSelectedTire = savedTires[0]?.id === tire?.id
    if (isSelectedTire) {
      const selectedTireQuantity = finalArr.filter((item) => item.tireId === savedTires[0].id)

      dispatch({
        type: "TIRE_CART_ITEM",
        payload: {
          cartTireObject: savedTires[0],
          tireQuantity: selectedTireQuantity.length === 0 ? 4 : selectedTireQuantity[0].quantity
        }
      })
    }
  }

  const handleAddToCartBtn = (tire) => {
    const selectedTireQuantity = tireQty.filter((item) => item.tireId === tire.id)
    dispatch({
      type: "TIRE_CART_ITEM",
      payload: {
        cartTireObject: tire,
        tireQuantity: selectedTireQuantity.length === 0 ? 4 : selectedTireQuantity[0].quantity
      }
    })
    trackFirebaseAnalytics({
      event: gaJSON.add_to_cart_from_results,
      params: {
        vehicle_id: activeVehicle.id,
        user_role: user.roles.toString(),
        source: tire.supplier === "tirehubdropship" ? "TireHub" : "NTW"
      }
    })

    setSelectedTire(tire)
  }

  const handleCartWarningDialog = () => {
    setOpenCarWarningDialog((prev) => !prev)
  }

  const removeCart = () => {
    handleDeleteTire()
    handleCartWarningDialog()
  }

  const isSameTireSelectedWithOneTireOnly = () => {
    return (
      !isEmpty(tires) &&
      tires.length === 1 &&
      !isEmpty(selectedTire) &&
      selectedTire.id &&
      tires.findIndex((tires) => tires.id === selectedTire.id) > -1
    )
  }

  const nextClick = () => {
    if (!selectedTire.id) return

    history.push({
      pathname: navigationPaths.tireSelectShop()
    })
  }
  return (
    <>
      <h2 className="text-lg font-semibold !my-4 text-center tires-step-header">
        Step 3 / 6: Select Tires
      </h2>
      <div className="top-tires-section mb-[100px]">
        <div className="tire__filter-desktop">
          {isLoading ? (
            <div className="tire__filter-animation"></div>
          ) : (
            <TireFilterAndSearch360
              handleSelectedFilter={handleSelectedFilter}
              filters={filters}
              tireSelectedFilters={tireSelectedFilters}
              tires={tires}
            />
          )}
        </div>
        <div className="top-tires">
          <div className="tires-top-banner">
            <Image className="tires-icon-margin" src={TierTopIcon} />
            <p className="tires-top-banner-content">
              <b>{t("tiresBannerMessage1")}</b> {t("tiresBannerMessage2")}
            </p>
          </div>
          <div className="mobile__tire-filter">
            <div className="mobile__tire-btn" onClick={handleFilterDrawer}>
              <ReactSVG src={FilterLogo} />
              <p>{t("tiersFilter:filterAndShort")}</p>
            </div>
          </div>

          <div className="tires-subheading-section">
            <div className="tire-vehicles-detail-section">
              <div className="vehicle-dropdown-section">
                <span className="label-style">{t("VehicleLabel")}</span>
                <div className="vehicle-selector">
                  <div className="vehicle-content">
                    <Image src={CarIconForUpdate} />
                    <span className="vehicle-text">{activeVehicle?.name}</span>
                  </div>
                  <Button
                    basic
                    size="small"
                    className="change-button"
                    onClick={() => history.go(-2)}
                  >
                    Change
                  </Button>
                </div>
              </div>

              <div className="tire-size-dropdown-section">
                <span className={`label-style`}>{t("tireSizeLabel")}</span>
                <div className="vehicle-selector">
                  <div className="vehicle-content">
                    <span className="vehicle-text">{selectedTireSizeData?.key}</span>
                  </div>
                  <Button
                    basic
                    size="small"
                    className="change-button"
                    onClick={() => history.goBack()}
                  >
                    Change
                  </Button>
                </div>
              </div>
            </div>
          </div>

          {selectedTire && selectedTire.id && (
            <>
              <p className="tire-lable">{t("selectedTires")}</p>
              <div className="tires">
                <div className="align-loader-center">
                  <div className="card-parent selected-tire-parent">
                    <div className="tires-card-parent ">
                      <TireDetailsSize
                        tire={savedTires[0]}
                        tireQty={[
                          {
                            tireId: savedTires[0].id,
                            quantity: cartTiersQuantity,
                            price: savedTires[0].price
                          }
                        ]}
                        changeHandler={changeHandler}
                        selectedTire={savedTires[0]}
                        openDeleteModal={openDeleteModal}
                        handleAddToCartBtn={handleAddToCartBtn}
                        t={t}
                        objectCollection={objectCollection}
                        saveSelectedTire={savedTires}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          <>
            {tires.length > 0 && (
              <div className="tires-help-section">
                {isLoading ? null : (
                  <>
                    <span className="tire-count-text">
                      {formatParagraph(t("tireCountLabel", { tireCount: tires.length }), 700)}
                    </span>
                  </>
                )}
              </div>
            )}
            {shouldApplyFilterRendered(tireSelectedFilters) &&
              (isMobile || isTablet ? isFilterAppliedOnMobile : true) && (
                <TireAppliedFilters
                  handleClearFilter={handleClearFilter}
                  handleClearAllFilters={handleClearAllFilters}
                  selectedFilters={tireSelectedFilters}
                />
              )}
            <div className="tires">
              <div className="align-loader-center">
                {isLoading || isFilterApiCalling ? (
                  <TopTireShimmer />
                ) : (
                  <div className="tire-card-button-parent">
                    <div
                      className={`${
                        isSameTireSelectedWithOneTireOnly()
                          ? "card-parent-container"
                          : "card-parent"
                      }`}
                    >
                      <div
                        className={`tires-card-parent ${
                          !(tires && tires.length) ? "placeholder_contianer" : ""
                        }`}
                      >
                        {tires.length > 0 ? (
                          (() => {
                            let tiresList = [...(tires || [])].filter(
                              (tire) => tire.id !== selectedTire.id
                            )

                            return tiresList.map((tire) => (
                              <TireDetailsSize
                                key={tire.id}
                                tire={tire}
                                tireQty={tireQty}
                                changeHandler={changeHandler}
                                selectedTire={selectedTire}
                                openDeleteModal={openDeleteModal}
                                handleAddToCartBtn={handleAddToCartBtn}
                                t={t}
                                objectCollection={objectCollection}
                                saveSelectedTire={saveSelectedTire}
                              />
                            ))
                          })()
                        ) : (
                          <div className="no-tier-section">
                            <p className="no_tier_header">{t("noTiresFound")}</p>
                            <p className="no_tier">{t("noTiresFoundMessage")}</p>
                          </div>
                        )}
                      </div>
                    </div>
                    {isSameTireSelectedWithOneTireOnly() && (
                      <div className="one-tire-card-section">
                        <p className="tire-info">{t("brandHasOneTire")}</p>
                        <p className="tire-info">{t("selectedSame")}</p>
                        <p className="tire-info">{t("haveLookSelectedTire")}</p>
                      </div>
                    )}
                  </div>
                )}
                <Confirm
                  open={openModal}
                  onCancel={closeModal}
                  onConfirm={handleDeleteTire}
                  content={t("areYouSure")}
                  className="delete-modal"
                />
                <CartWarningDialog
                  openCarWarningDialog={openCarWarningDialog}
                  handleCartWarningDialog={handleCartWarningDialog}
                  removeCart={removeCart}
                />
              </div>
            </div>
          </>
        </div>
        <FilterDrawer
          open={openFilterDrawer}
          filters={filters}
          tireSelectedFilters={tireSelectedFilters}
          handleFilterDrawer={handleFilterDrawer}
          handleSelectedFilter={handleSelectedFilter}
          clearTireFilters={handleClearAllFilters}
          fetchTireList={fetchTireDataOnMobile}
          tires={tires}
          isFilterApiCalling={isFilterApiCalling || isLoading}
        />
      </div>
      <TiresBottomNav
        goBack={() => history.goBack()}
        nextBtnText={"Continue to tire installation"}
        nextDisabled={selectedTire.id}
        next={nextClick}
      />
    </>
  )
}

function mapStateToProps(state) {
  const user = state.application.userSessionData || (state.users && state.users.currentUser)
  let savedTires = state.tires.tireDetails ? [state.tires.tireDetails] : []
  let cartTireQuantity = state.tires.tireQuantity ?? 4
  return {
    user: user,
    activeVehicle: state.tires.vehicle,
    savedTires: savedTires,
    selectedTireSizeData: state.tires.selectedRim,
    preSelectedFilters: state.tires.filters,
    cartTiersQuantity: cartTireQuantity
  }
}

export default connect(mapStateToProps, {
  saveTireDetails,
  getFilteredListOfTires,
  saveSelectedTire,
  getRimSize,
  resetTireData,
  saveTireSizeDetails,
  dispatch: (action) => action
})(withTranslation("topTires")(SelectTire))
